import { Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";

const CommonFormButton = (props) => {
  if(props.ghostButton) {
    return (
      <ButtonGroup display="flex">
        <Button
          variant="posghost"
          onClick={props.onClick}
          isDisabled={props.isDisabled}
        >
          {props.buttonText}
        </Button>
      </ButtonGroup>
    );
  } else if (props.CancelButton) {
    return (
      <ButtonGroup display="flex">
        <Button
          variant="outline"
          onClick={props.onClick}
          width={props.buttonText === "Cancel" ? "7.37rem" : undefined}
          isDisabled={props.isDisabled}
        >
          {props.buttonText}
        </Button>
      </ButtonGroup>
    );
  } else if (props.SubmitButton) {
    return (
      <ButtonGroup
        display="flex"
        justifyContent={{ base: "center", md: "flex-end" }}
        mx={{ base: 0, md: 4 }}
      >
        <Button
          variant="solid"
          width={props.buttonsubmit === "Submit" ? "7.37rem" : undefined}
          onClick={props.onClick}
          isDisabled={props.isDisabled}
        >
          {props.buttonsubmit}
        </Button>
      </ButtonGroup>
    );
  } else {
    return (
      <Button
        variant="solid"
        width={props.width}
        onClick={props.onClick}
        isDisabled={props.isDisabled}
        leftIcon={props.icon}
        //new added
        bg="rgba(255, 255, 255, 0.1)"
        color="white"
        backdropFilter="blur(10px)"
        border="1px solid rgba(255, 255, 255, 0.2)"
        px={14}
        _hover={{
          bg: "rgba(255, 255, 255, 0.2)",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
        }}
        _active={{
          bg: "rgba(255, 255, 255, 0.3)",
          boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.4)",
        }}
        whileTap={{
          scale: 0.98,
          backgroundColor: "rgba(255, 255, 255, 0.4)",
        }}
      >
        {props.buttonsubmit}
      </Button>
    );
  }
};

export default CommonFormButton;
